var App = App || {};

App.AppointmentButton = (function ($) {
    'use strict';

    function Init() {
        var $button = $(".appointment-button");

        if (!$button.length) {
            return;
        }

        $("body").waypoint({
            handler: function (direction) {
                if (direction === "down") {
                    $button.addClass("is-visible");
                } else {
                    $button.removeClass("is-visible");
                }
            },
            offset: "-100px"
        });
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.AppointmentButton.Init();
});
